<template>
  <div class="tag" :class="tagClasses">
    <IconComponent v-if="icon" :name="icon" :size="size" :key="icon + size" />
    <slot></slot>
  </div>
</template>

<script setup>
/**
 * Imports
 */
import { computed } from "vue";

/**
 * Props & Emits
 */
const props = defineProps({
  color: {
    type: String,
    default: "gray",
    validator: (value) =>
      [
        "red",
        "red-light",
        "yellow",
        "green",
        "green-dark",
        "green-light",
        "purple",
        "purple-light",
        "purple-4",
        "black",
        "blue",
        "blue-light",
        "gray",
      ].includes(value),
  },
  size: {
    type: String,
    default: "md",
    validator: (value) => ["sm", "md", "lg", "xl"].includes(value),
  },
  icon: {
    type: String,
    default: "",
  },
  iconSize: {
    type: String,
  },
});

/**
 * Variables
 */

/**
 * Computed
 */
const tagClasses = computed(() => {
  return `tag--${props.color} tag--${props.size}`;
});

/**
 * Methods
 */

/**
 * Hooks, Watchers
 */
</script>

<style lang="stylus">
.tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px
  border-radius: 6px;
  font-weight: 500;
  line-height 1

  // Размеры
  &--sm {
    padding: 3px 5px;
    gap: 4px
    font-size: 0.75rem
  }

  &--md {
    padding: 4px 8px;
    font-size: 0.875rem
  }

  &--lg {
    padding: 5px 10px
    font-size 1rem
    height 32px
  }

  &--xl {
    padding: 5px 10px
    font-size 1.125rem
    height 34px
  }

  // Цвета
  &--red {
    color: var(--white)
    background: var(--red)
  }

  &--red-light {
    color: var(--red)
    background-color: var(--red-2)
  }

  &--yellow {
    color: var(--white)
    background: var(--yellow)
  }

  &--green {
    color: var(--white)
    background-color: var(--green)
  }

  &--green-dark {
    color: var(--white)
    background-color: var(--green-2)
  }

  &--green-light {
    color: var(--green)
    background-color: var(--green-3)
  }

  &--purple {
    color: var(--white)
    background-color: var(--purple)
  }

  &--purple-light {
    color: var(--purple)
    background-color: var(--purple-2)
  }

  &--purple-4 {
    color: var(--purple-4)
    background-color: var(--purple-3)
  }

  &--black {
    color: var(--white)
    background-color: var(--black)
  }

  &--blue {
    color: var(--white)
    background var(--blue)
  }

  &--blue-light {
    color: var(--blue-3)
    background: var(--blue-light-2)
  }

  &--gray {
    color: var(--white)
    background var(--gray-6)
  }
}
</style>
